import React, { useState, useEffect } from "react";

const ActiviteForm = ({ activiteForm, activiteFormData }) => {

  const data = [
    "Accès aux marches publiques",
    "Conformité avec les exigences des institutions nationale - CNPS",
    "Conformité avec les exigences des institutions nationale - DGI",
    "Accompagnement au montage des projets - Démarrage, croissance- internationalisation",
    "Accueil des PMEs dans le cadre du programme de financement",
    "Garanties en faveur des institutions financières",
    "Conférence - Conformité - normalisation standards internationaux",
    "Formation financière à livrer par IFC",
    "Formation à livrer par CI-PME sur des thèmes à succès"
  ];

  const [activite, setActivite] = useState({
    activite: data[0],
    isValid: false,
    ...activiteForm,
  });

  const handleChange = (e) => {
    console.log(activite, "activite")
    setActivite({
      ...activite,
      [e.target.name]: e.target.value,
      id: Date.now(),
    });
  };

  useEffect(() => {
    if(activite.activite){
      setActivite({...activite, isValid: true})
    }
    else{
      setActivite({...activite, isValid: false})
    }
    activiteFormData(activite);
  }, [activite]);

  return (
    <div>
      <form class="row g-3">
        <div class="col-md-12">
        <label for="mobile" class="form-label">
          ACTIVITES JPO
        </label>
          <select
            class="form-select form-select-lg mb-3 form-input-droit"
            aria-label="Large select example"
            name="activite"
            value={activite.activite}
            onChange={handleChange}
          >
            {data && data.map((item) => <option value={item}>{item}</option>)}
          </select>
        </div>
      </form>
    </div>
  );
};

export default ActiviteForm;
